exports.API_URL = "https://api.kratom.wankaew.com"
// exports.API_URL = "http://localhost:9202"
exports.ROOT = "https://kratom.wankaew.com"
// exports.ROOT = "http://192.168.0.99:3000"

